<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 基础设置 > 舌面释义
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="部位" style="margin-left: 10px;">
								<el-select @change="changeBody" v-model="searchData.body" placeholder="请选择">
									<el-option value="">请选择</el-option>
								    <el-option
								      v-for="item in bodyOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
								  </el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" label="分类" style="margin-left: 10px;">
								<el-select v-model="searchData.sort" placeholder="请选择">
									<el-option value="">请选择</el-option>
								    <el-option
								      v-for="item in sortOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
								  </el-select>
								 
							</el-form-item>
							<el-form-item class="el-form-item-line" label="诊断结果" style="margin-left: 10px;">
								
								  <el-input class="longInput"
								  	v-model="searchData.result"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
								
								
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>

							<el-table-column width="180" align="center" label="部位" prop="bodyPart">
							</el-table-column>
							<el-table-column width="180" align="center" label="分类" prop="type">
							</el-table-column>
							<el-table-column width="180" align="center" label="诊断结果" prop="value">
							</el-table-column>
							<el-table-column align="center" label="临床意义" prop="significance">
								
								<template #default="{row}">
									<div>
										{{ row.significance ? row.significance : "暂无" }}
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增舌面释义' : '编辑舌面释义'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item class="el-form-item-line" label="部位" prop="body">
									<el-select @change="changeBody"  :disabled="addOrEdit == 'edit'"  v-model="addUserForm.body" placeholder="请选择">
										<el-option
									      v-for="item in bodyOptions"
									      :key="item.value"
									      :label="item.label"
									      :value="item.value">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item class="el-form-item-line" label="分类" prop="sort">
									<el-select :disabled="addOrEdit == 'edit'"  v-model="addUserForm.sort" placeholder="请选择">
										<el-option
									      v-for="item in sortOptions"
									      :key="item.value"
									      :label="item.label"
									      :value="item.value">
									    </el-option>
									  </el-select>
								</el-form-item>

								<el-form-item label="诊断结果" prop="result">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" class="longInput"
										v-model="addUserForm.result"></el-input>
								</el-form-item>
								
								<el-form-item label="临床意义" prop="performance">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" class="longInput"
										v-model="addUserForm.performance"></el-input>
								</el-form-item>
								
								<el-form-item style="display: none;" label="图片" prop="pic">
									<el-autocomplete popper-class="my-autocomplete" v-model="addUserForm.pic"
										:fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
										<template #prefix>
										    <el-icon class="el-input__icon"><Search></Search></el-icon>
										</template>
										<template #default="{item}">
											<div class="img">
												<img :src="globalImageUrl + item.path" />
												<span class="name">{{ item.name }}</span>
											</div>
										</template>
									</el-autocomplete>
									<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
								</el-form-item>
								<div class="select" v-if="selectedPicList.length > 0">
									<ul class="select-ul">
										<li v-for="(item, index) in selectedPicList" :key="index">
											<div class="path">
												<img :src="globalImageUrl + item.path" />
											</div>
											<span class="name">{{ item.name }}</span>
										</li>
									</ul>
									<ul class="selected-ul">
										<span class="span">已选择的图片：</span>
										<div class="li">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<span class="name">{{ item.name }}</span>
												<i @click="handleClose(item)" class="el-icon-circle-close"></i>
											</li>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</el-form>
				</div>
				
				<template class="dialog-footer" #footer>
					
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large"  class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	export default {
		data() {
			return {
				total: 0,
				currentPage: 0,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "舌面释义",
					},
					{
						id: 1,
						name: "报告结果",
					},
					{
						id: 2,
						name: "规则设置",
					},
					{
						id: 3,
						name: "养生方案",
					},
					{
						id: 4,
						name: "版本管理",
					},

				],
				currentTabIndex: 0,
				searchData: {
					body: "", 
					sort: "",
					result:''
				},
				bodyOptions:[
					{
						value: '舌',
						label: '舌'
					},
					{
						value: '面',
						label: '面'
					}
				],
				sortOptions:[],				
				tongueOptions:[
					{
						value: '舌色',
						label: '舌色'
					},
					{
						value: '舌形',
						label: '舌形'
					},
					{
						value: '苔色',
						label: '苔色'
					},
					{
						value: '苔质',
						label: '苔质'
					}
				],
				faceOptions:[
					{
						value: '面色',
						label: '面色'
					},
					{
						value: '光泽度',
						label: '光泽度'
					},
					{
						value: '唇色',
						label: '唇色'
					},
					{
						value: '眼眶',
						label: '眼眶'
					}
				],
				resultOptions:[
					{
						value: '淡白',
						label: '淡白'
					},
					{
						value: '淡红',
						label: '淡红'
					},
					{
						value: '鲜红',
						label: '鲜红'
					},
					{
						value: '红绛',
						label: '红绛'
					},
					{
						value: '暗红',
						label: '暗红'
					},
					{
						value: '青紫',
						label: '青紫'
					}
				],
				tableListData: [],
				addUserForm: {
					body: "", //整体特征
					sort:'',
					result: "", //心里特征
					performance: "", //常见表现
					pic: "", //图片
					id: "",
					createTime: "",
				},
				
				rules: {
					body: [{
						required: true,
						message: "请选择部位",
						trigger: "blur",
					}, ],
					sort: [{
						required: true,
						message: "请选择分类",
						trigger: "blur",
					}, ],
					result: [{
						required: true,
						message: "请输入诊断结果",
						trigger: "blur",
					}, ],
										
				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				picList: [],
				selectedPicList: [], //被选中的图片
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/basicSetting/tongueInterpretation",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/basicSetting/reportResult",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/basicSetting/ruleSetting",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/basicSetting/healthPlan",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/basicSetting/versionManagement",
					});
				}

			},
			//重置
			reset(){
				this.searchData.body = '';
				this.searchData.sort = '';
				this.searchData.result = '';
				this.searchPluse();
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.body = "";
				this.addUserForm.sort = "";
				this.addUserForm.performance = "";
				this.addUserForm.result = "";
				this.addUserForm.id = "";
				this.addUserForm.createTime = "";
				this.selectedPicList = [];
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//编辑脉象
			edit(item) {
				this.addOrEdit = "edit";
				this.getDetail(item.id);
			},
			//获取详情
			getDetail(id) {
				this.$applicationJson("/business/baseExplain/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.sort = item.type;
							this.addUserForm.id = item.id;
							this.addUserForm.body = item.bodyPart;
							if(item.bodyPart == '舌'){
								this.sortOptions = this.tongueOptions
							}
							if(item.bodyPart == '面'){
								this.sortOptions = this.faceOptions
							}
							this.addUserForm.result = item.value;
							this.addUserForm.performance = item.significance;
							this.addUserForm.createTime = item.createTime;
							this.addUserFlag = true;
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						this.delConstitute(item.id);
					})
					.catch(() => {});
			},
			
			//切换部位
			changeBody(val){
				this.searchData.sort = '';
				if(val == '舌'){
					this.sortOptions = this.tongueOptions
				}
				if(val == '面'){
					this.sortOptions = this.faceOptions
				}
			},
			
			//取消
			cancelPatient() {
				this.addUserFlag = false;
				this.reset();
			},
			//确定
			addPatient(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add") {
							this.addConstitute();
						}
						if (this.addOrEdit == "edit") {
							this.editConstitute();
						}
						this.reset();
						this.currentPage = 0;
					} else {
						return false;
					}
				});
			},
			//新增舌面释义
			addConstitute() {
				this.$applicationJson("/business/baseExplain/add", {
						type: this.addUserForm.sort,
						createTime: "",
						bodyPart: this.addUserForm.body,
						value: this.addUserForm.result,
						significance: this.addUserForm.performance,
						id: "",
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//编辑体质
			editConstitute() {
				this.$applicationJson("/business/baseExplain/edit", {
						type: this.addUserForm.sort,
						createTime: this.addUserForm.createTime,
						bodyPart: this.addUserForm.body,
						value: this.addUserForm.result,
						significance: this.addUserForm.performance,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除
			delConstitute(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/baseExplain/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.getPlanList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getPlanList(this.currentPage);
			},
			//搜索
			searchPluse() {
				this.getPlanList(0);
			},
			//获取舌面列表
			getPlanList(currentPage) {
				this.$applicationJson("/business/baseExplain/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							bodyPart: this.searchData.body, //部位
							type: this.searchData.sort, 
							value:this.searchData.result 
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			//搜索切换类型
			changeType(val) {
				this.getPlanList(0);
				this.currentPage = 0;
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0,4);
				}
				this.getPlanList(0);
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);
				.con {
					min-height: calc(100% - 80px);
					.search-con {
						height: 120px;
						@media screen and (min-width: 1450px) and (max-width: 1920px) {
							height: 70px;
							width: 100%;
						}
						
					}
				}
			}
			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
			.demo-form-inline {
				margin-top: 10px;
				:deep(.el-input__inner){
					width: 160px;
				}
			}
			.editor {
				cursor: pointer;
				color: #679ff6;
			}
			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}
			.search-con {
				@media screen and (min-width: 0px) and (max-width: 1060px) {
					height: 180px;
					width: 100%;
				}
				@media screen and (min-width: 1060px) and (max-width: 1280px) {
					height: 130px;
					width: 100%;
				}
				@media (min-width: 1280px) {
					width: 100%;
					height: 130px;
				}
				@media (min-width: 1480px) {
					width: 100%;
					height: 70px;
				}
				@media screen and (min-width: 1480px) and (max-width: 1856px) {
					height: 130px;
					width: 100%;
				}
				@media (min-width: 1920px) {
					width: 100%;
					height: 70px;
				}
			}
		}
	}

	.dialog {
		:deep(.el-dialog__body) {
			padding: 0;
			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				height: 300px;
				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}
						.el-form-item {
							width: 100%;
						}
						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}
						.dialog-tit {
							height: 40px;
							line-height: 40px;
							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}
							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}
				.longInput {
					width: 100%;
					:deep(.el-input__inner){
						width: 100%;
					}
				}
				.smallInput {
					width: 150px;
					:deep(.el-input__inner) {
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;
		img {
			float: left;
			width: 40px;
		}
		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}
	.select {
		margin-left: 40px;
		width: calc(100% - 40px);
		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;
			li {
				float: left;
				width: 120px;
				text-align: center;
				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}
					width: 40px;
					height: 40px;
				}
				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}
		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;
			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}
			.li {
				float: left;
				width: calc(100% - 110px);
				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;
					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}
					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
